module.exports = __webpack_public_path__ + "static/media/orange-bg-square.4e003788.webp";